define([
	"dojo/_base/declare",
	"csi/html",
	"csi/locale",
	"csi/types",
	"csi/middleware/customView/customViewDataManagementService",
	"csi/xml",
	"./String"
], function(declare, html, locale, types, {stringNonTextFormatOperators}, xml, StringRen) {

	return declare(StringRen, {
		displayRawAddress: false,
		tagAction: "ActionStringURL",
		queryOps: stringNonTextFormatOperators,
		_default: null,

		constructor: function() {
			// summary: store default name for Href
			this._default = locale.resource("StringURL_Text");
		},

		canLink: function() {
			// summary: hyperlinks are already anchors
			return false;
		},

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: convert value to name
			return types.parseSerializedHyperlink(value).name;
		},

		/**
		 * @override
		 * allow filter in custom view to select from existing values
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.allowFilteringBySelectionOfExistingValues = true;
			return qs;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render url value for attribute in HTML
			var value = this._getValue(ctx, h);
			if (value) {
				var parsedHyperlink = types.parseSerializedHyperlink(value);

				if (this.displayRawAddress) {
					var linkText = value;
				} else {
					var linkText = parsedHyperlink.name || parsedHyperlink.addr;
				}

				if (parsedHyperlink.addr && !ctx.bStatic) {
					// include address when printing URL with name that is different from address
					if (ctx.bPrint) {
						var addr = parsedHyperlink.addr.replace(xml.RE_WEB, '');
						if (addr != parsedHyperlink.name && parsedHyperlink.name != '') {
							html.text(refNode, parsedHyperlink.name + ': ');
						}
						linkText = addr;
					}

					refNode = html.a({
						href: parsedHyperlink.addr,
						onclick: html.stopPropagation,
						target: "_blank"
					}, refNode);
				}
				html.text(refNode, linkText);
				return true;
			}

			return false;
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: action will be used for tooltip
			var ad = this.inherited(arguments);
			if (ad) {
				ad.bTooltip = !ctx.view.useMuiTooltipStyling;
			}

			return ad;
		},

		_toSortValue: function(/*Any*/value) {
			// summary: sort by name
			return types.parseSerializedHyperlink(value).name;
		}
	});
});